import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { promoPlansQuery as PromoPlansQuery } from "@zapier/checkout/esm/graphql-types";
import { QueryResult, UseQuery } from "@zapier/checkout/esm/types";

export const promoPlansQuery = gql`
  query promoPlansQuery {
    promoPlans {
      amount
      name
      id
      interval
      tasks
      tiers {
        numTasks
        pricePerTask
      }
      type
      zaps
    }
  }
`;

export const usePromoPlans = (useQuery: UseQuery = defaultUseQuery) => {
  const { data, error, loading }: QueryResult<PromoPlansQuery> = useQuery(
    promoPlansQuery,
    {}
  );
  const promoPlans = data?.promoPlans ?? [];

  return {
    /**
     * empty promo plans list means either:
     *   - user isn't eligible for any promo plans, or
     *   - user is eligible for a promo plan that only offers a monthly billing interval
     */
    allowIntervalSelection: promoPlans.length > 0,
    error: error
      ? "Error getting promo plans for this user. Please try again."
      : undefined,
    isLoading: loading,
    promoPlans,
  };
};
